<template>
  <div class="main">
    <!-- <SyncLoading /> -->

    <div class="maincon">
      <div class="flexbox tabs">
        <div
          class="cell"
          @click="clickTab(index)"
          :class="{ active: index == tabs_index }"
          v-for="(item, index) in tabs"
          :key="index"
        >
          {{ item.name }}
        </div>
        <!-- <div class="cell">项目订单</div> -->
        <!-- <div class="cell">样品订单</div> -->
      </div>
      <div class="cartbox">
        <div class="stepbox">
          <el-steps
            :space="200"
            :active="0"
            finish-status="success"
            align-center
          >
            <el-step title="加入购物车"></el-step>
            <el-step title="填写核对订单信息"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </div>
        <div class="cartcon" v-if="cartList.length > 0">
          <div class="item" v-for="(item, index) in cartList" :key="index">
            <h2 class="flexbox">
              <p>{{ item.bhxsName }}</p>
              <!-- <span>项目号：</span>
                            <span>项目名称：</span> -->
            </h2>
            <div class="flexbox top">
              <div class="checkbox">
                <el-checkbox
                  v-model="item.selall"
                  @change="selectAll('sigall', item.selall, index)"
                  >全选</el-checkbox
                >
              </div>
              <div class="msg">商品信息</div>
              <div class="stock">库存</div>
              <div class="deliver">预计发货天数</div>
              <div class="price">单价</div>
              <div class="num">数量（个）</div>
              <div class="cases">箱数（箱）</div>
              <div class="weight">重量</div>
              <div class="total">合计</div>
            </div>
            <div
              class="flexbox cell"
              v-for="(it, idx) in item.proData"
              :key="it.tsdId"
            >
              <div class="checkbox">
                <el-checkbox
                  v-model="it.selsig"
                  @change="selectAll('sigorder', it.selsig, index)"
                ></el-checkbox>
              </div>
              <div class="flexbox msg">
                <div class="img">
                  <img
                    src="https://online.meide-casting.com/meide/la.img?fn"
                    @click="pageToDetail(it.jppz, it.cz, it.xs)"
                  />
                </div>
                <div class="name">
                  <p>{{ it.name }}</p>
                  <p>{{ it.code }}</p>
                  <span>规格:</span>
                  <span class="redw" style="margin-right: 8px">{{
                    it.gg
                  }}</span>
                  <span>表面:</span>
                  <span class="redw" style="margin-right: 8px">{{
                    it.bm
                  }}</span>
                  <span>品种:</span>
                  <span class="redw">{{ it.pz }}</span>
                  <div>
                    <span v-if="it.jq">胶圈:</span>
                    <span v-if="it.jq" class="redw" style="margin-right: 8px">{{
                      it.jq
                    }}</span>
                    <span v-if="it.lslm"> 螺栓螺母:</span>

                    <span
                      v-if="it.lslm"
                      class="redw"
                      style="margin-right: 8px"
                      >{{ it.lslm }}</span
                    >
                    <span>{{ it.stockTypeName }}</span>
                  </div>
                </div>
              </div>
              <div class="stock" v-if="it.stockSign == 'Y'">有</div>
              <div class="stock" v-if="it.stockSign == 'N'">不足</div>
              <div class="deliver">{{ it.days }}天</div>
              <div class="price">
                <div class="redw">¥{{ it.price }}</div>
                <div class="grayw">¥{{ it.hxPrice }}</div>
              </div>
              <div class="num">
                <el-input-number
                  size="mini"
                  v-model="it.num"
                  :min="1"
                  :max="Infinity"
                  :controls="false"
                  @blur="
                    numChange(
                      'jian',
                      index,
                      idx,
                      it.num,
                      it.caseNum,
                      it.weight,
                      it.price,
                      it.stockNum
                    )
                  "
                ></el-input-number>
              </div>
              <div class="cases">
                <el-input-number
                  size="mini"
                  v-model="it.boxNum"
                  :min="1"
                  :max="Infinity"
                  :controls="false"
                  @blur="
                    numChange(
                      'xiang',
                      index,
                      idx,
                      it.boxNum,
                      it.caseNum,
                      it.weight,
                      it.price,
                      it.stockNum
                    )
                  "
                ></el-input-number>
              </div>
              <div class="weight">{{ it.weightAll }}KG</div>
              <div class="redw total">¥{{ it.totalPrice }}</div>
            </div>
          </div>
        </div>
        <div class="nodata" v-if="cartList.length == 0">
          <el-empty description="购物车是空的"></el-empty>
        </div>
        <div class="totalall" v-if="cartList.length > 0">
          <div class="flexbox totalallcon">
            <div class="flexbox left">
              <el-checkbox
                v-if="tabs_index == 0"
                v-model="realSelAll"
                @change="selectAll('botall', realSelAll, '')"
                >全选</el-checkbox
              >
              <el-button type="text" @click="deletGoods"
                >删除选中商品</el-button
              >
              <!-- <el-button type="text" @click="productCollect">移入收藏夹</el-button> -->
              <!-- <el-button type="text" @click="allKcCheck">库存刷新</el-button> -->
            </div>
            <div class="flexbox right">
              <p>
                共{{ chorderNum }}种商品，已选择
                <span class="redw">{{ totalSelNum }}</span> 种
              </p>
              |
              <!-- <p>商品合计 : ¥{{totalhxPrice}}</p>| -->
              <p>商品总重 : {{ totalWeight }}</p>
              |

              <p>总箱数 : {{ totalBoxNum }}</p>
              |
              <p>总数量 : {{ totalNum }}</p>
              |

              <p>
                应付总额：<span class="redw large">¥{{ totalPricereal }}</span>
              </p>
              <div class="submitbtn" @click="priceCompare">去结算</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  getCurrentInstance,
  onBeforeMount,
  computed,
  watch,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { Nummul, Numadd } from "@/util/util.js";
import { useStore } from "vuex";

import SyncLoading from "@/components/syncLoading/SyncLoding.vue";
export default {
  name: "ShoppingCart",
  components: {
    SyncLoading,
  },
  setup() {
    let tabs = ref([
      { name: "购物车" },
      { name: "项目订单" },
      { name: "异地仓订单" },
    ]);
    let tabs_index = ref(0);
    let { proxy } = getCurrentInstance();
    let router = useRouter();
    let store = useStore();
    let pageData = reactive({
      activeName: "first",
      cartList: [], // 购物车内容
      chorderNum: 0, // 子单数量
      realSelAll: false, // 页面全部子单的全选
    });
    // 获取购物车内容
    let getShoppingCart = () => {
      let data = {
        postType: "query",
        type: orderType.value, // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxShopCar", data)
        .then((res) => {
          if (res.success == "true") {
            res.data.map((item) => {
              item.selall = false;
              item.proData.map((it) => {
                it.selsig = false;
                it.weightAll = (it.weight * it.num).toFixed(2);
                it.totalPrice = Nummul(it.num, it.price).toFixed(2);
              });
            });
            pageData.chorderNum = res.productNum;
            pageData.cartList = res.data;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    // 全选操作
    let selectAll = (type, val, idx) => {
      if (type == "sigall") {
        // 二级订单全选
        if (val) {
          pageData.cartList[idx].proData.map((item) => {
            item.selsig = true;
          });
        } else {
          pageData.cartList[idx].proData.map((item) => {
            item.selsig = false;
            pageData.realSelAll = false;
          });
        }
        pageData.realSelAll = true; // 总订单
        pageData.cartList.map((item) => {
          item.proData.map((it) => {
            if (!it.selsig) {
              pageData.realSelAll = false;
            }
          });
        });
      } else if (type == "botall") {
        // 总订单全选
        if (val) {
          pageData.cartList.map((item) => {
            item.selall = true;
            item.proData.map((it) => {
              it.selsig = true;
            });
          });
        } else {
          pageData.cartList.map((item) => {
            item.selall = false;
            item.proData.map((it) => {
              it.selsig = false;
            });
          });
        }
      } else if (type == "sigorder") {
        // 单个子单选择
        pageData.cartList[idx].selall = true; // 二级订单
        pageData.realSelAll = true; // 总订单
        pageData.cartList.map((item) => {
          item.proData.map((it) => {
            if (!it.selsig) {
              item.selall = false;
              pageData.realSelAll = false;
            }
          });
        });
      }
    };
    // 计算价格、重量
    let totalhxPrice = computed(() => {
      let jg = 0;
      pageData.cartList.map((item) => {
        item.proData.map((it) => {
          if (it.selsig) {
            let xcjg = Nummul(it.hxPrice, it.num);
            jg = Numadd(jg, xcjg);
          }
        });
      });
      return jg.toFixed(2);
    });
    //应付总额
    let totalPricereal = computed(() => {
      let jg = 0;
      pageData.cartList.map((item) => {
        item.proData.map((it) => {
          if (it.selsig) {
            jg = Numadd(jg, it.totalPrice);
            // jg = Numadd(jg, Nummul(it.num, it.price))
          }
        });
      });
      return jg.toFixed(2);
    });
    // 已选择数量
    let totalSelNum = computed(() => {
      let num = 0;
      pageData.cartList.map((item) => {
        item.proData.map((it) => {
          if (it.selsig) {
            num += 1;
          }
        });
      });
      return num;
    });
    //商品总重量
    let totalWeight = computed(() => {
      let wei = 0;
      pageData.cartList.map((item) => {
        item.proData.map((it) => {
          if (it.selsig) {
            wei = Numadd(wei, it.weightAll);
          }
        });
      });
      return wei.toFixed(2);
    });

    //总箱数
    let totalBoxNum = computed(() => {
      let wei = 0;
      pageData.cartList.map((item) => {
        item.proData.map((it) => {
          if (it.selsig) {
            wei = Numadd(wei, it.boxNum);
          }
        });
      });

      return wei;
    });

    //总数量
    let totalNum = computed(() => {
      let wei = 0;
      pageData.cartList.map((item) => {
        item.proData.map((it) => {
          if (it.selsig) {
            wei = Numadd(wei, it.num);
          }
        });
      });

      return wei;
    });

    // 数量增减
    let numChange = (type, index, idx, num, chs, weight, price, kcnum) => {
      if (type == "jian") {
        numCheck(pageData.cartList[index].proData[idx].tsdId, num, chs);
        // kcCheck(pageData.cartList[index].proData[idx].code, num, index, idx)
        numCheckNum(num, kcnum, index, idx);
        pageData.cartList[index].proData[idx].boxNum = Math.ceil(num / chs);
        pageData.cartList[index].proData[idx].weightAll = (
          num * weight
        ).toFixed(2);
        pageData.cartList[index].proData[idx].totalPrice = Nummul(
          num,
          price
        ).toFixed(2);
      } else if (type == "xiang") {
        let jnum = num * chs;
        numCheck(pageData.cartList[index].proData[idx].tsdId, jnum, chs);
        // kcCheck(pageData.cartList[index].proData[idx].code, jnum, index, idx)
        numCheckNum(jnum, kcnum, index, idx);
        pageData.cartList[index].proData[idx].num = jnum;
        pageData.cartList[index].proData[idx].weightAll = (
          jnum * weight
        ).toFixed(2);
        pageData.cartList[index].proData[idx].totalPrice = Nummul(
          jnum,
          price
        ).toFixed(2);
      }
    };
    // 编辑数量
    let numCheck = (code, num, chs) => {
      let data = {
        postType: "editShopCar",
        tsdId: code, // 购物车子单号
        num: num, // 数量
        caseNum: chs, // 标准箱件数
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxShopCar", data)
        .then((res) => {
          if (res.success == "true") {
            // if(!res.flag) {
            //     proxy.$alert('当前库存不足，需进行生产，预计发货时间较长', '提示', {
            //         confirmButtonText: '确定',
            //         callback: action => {
            //         }
            //     })
            // }
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          proxy.$alert(error, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        });
    };
    // 批量库存刷新
    let allKcCheck = () => {
      pageData.cartList.map((item, index) => {
        item.proData.map((it, idx) => {
          kcCheck(it.code, it.num, index, idx);
        });
      });
    };
    // 库存校验-调用接口
    let kcCheck = (code, num, index, idx) => {
      let data = {
        postType: "queryStockByNum",
        productCode: code, // 产品编码
        num: num, // 产品数量
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxSelectProduct", data)
        .then((res) => {
          if (res.success == "true") {
            if (!res.flag) {
              pageData.cartList[index].proData[idx].stockSign = "N";
              ElMessage.warning({
                message: "当前库存不足，需进行生产，预计发货时间较长",
                type: "warning",
              });
            } else {
              pageData.cartList[index].proData[idx].stockSign = "Y";
            }
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          proxy.$alert(error, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        });
    };
    // 库存校验-比较数量
    let numCheckNum = (num, kcnum, index, idx) => {
      if (num > kcnum) {
        pageData.cartList[index].proData[idx].stockSign = "N";
      } else {
        pageData.cartList[index].proData[idx].stockSign = "Y";
      }
    };
    // 删除商品
    let delClick = ref(true);
    let deletGoods = () => {
      let seqs = [];
      pageData.cartList.map((item) => {
        item.proData.map((it) => {
          if (it.selsig) {
            seqs.push(it.tsdId);
          }
        });
      });
      if (seqs.length == 0) {
        proxy.$alert("请先选择商品", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            delClick.value = true;
          },
        });
        return;
      }
      if (delClick.value) {
        delClick.value = false;
        proxy.$confirm("确认要删除商品吗？", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            if (action == "confirm") {
              let data = {
                postType: "deleteFromShopCar",
                seq: seqs.join(","), // 购物车子单ID，多个用英文逗号隔开
              };
              proxy.$axios
                .postReq("/meide/REST/ajaxShopCar", data)
                .then((res) => {
                  if (res.success == "true") {
                    ElMessage.success({
                      message: res.Info,
                      type: "success",
                    });
                    getShoppingCart("1");
                    delClick.value = true;
                    setTimeout(() => {
                      store.commit("shopCartRe", true);
                    }, 1000);
                  } else {
                    proxy.$alert(res.ErrorText, "提示", {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        delClick.value = true;
                      },
                    });
                  }
                })
                .catch((error) => {
                  proxy.$alert(error, "提示", {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      delClick.value = true;
                    },
                  });
                });
            } else {
              delClick.value = true;
            }
          },
        });
      }
    };
    // 批量收藏
    let colClick = ref(true);
    let productCollect = () => {
      if (colClick.value) {
        colClick.value = false;
        let info = [];
        let ob = {
          PZ: "",
          XS: "",
        };
        pageData.cartList.map((item) => {
          item.proData.map((it) => {
            if (it.selsig) {
              ob.PZ = it.code;
              ob.PZ = it.name;
              info.push(ob);
            }
          });
        });
        if (info.length == "0") {
          proxy.$alert("未选中任何商品", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
          return;
        }
        let data = {
          postType: "collections",
          INFO: info, // [{"PZ":"130","XS":"777"},{"PZ":"130","XS":"7777"}]
        };
        proxy.$axios
          .postReq("/meide/REST/ajaxMdCollection", data)
          .then((res) => {
            if (res.success == "true") {
              ElMessage.success({
                message: res.Info,
                type: "success",
              });
              colClick.value = true;
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  colClick.value = true;
                },
              });
            }
          })
          .catch((error) => {
            proxy.$alert(error, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                colClick.value = true;
              },
            });
          });
      }
    };
    // 提交购物车-跳转结算
    let submitClick = ref(true);
    let cartSubmit = () => {
      let subdata = {
        data: [],
      };

      pageData.cartList.map((item) => {
        let obj = {
          bhxs: "",
          products: [],
        };
        item.proData.map((it) => {
          let ob = {
            tsdId: "", // 购物车子单ID
            code: "", // 产品编码
            num: "", // 数量
            boxNum: "", // 箱数
            packNum: "", // 标准箱件数
            stockType: "", // 库存类型
          };
          if (it.selsig) {
            console.log(it, "---------it--------------");
            ob.tsdId = it.tsdId;
            ob.code = it.code;
            ob.num = it.num;
            ob.boxNum = it.boxNum;
            ob.packNum = it.caseNum;
            ob.stockType = it.stockType;
            obj.products.push(ob);
            obj.bhxs = item.bhxs;
          }
        });
        if (obj.products.length != 0) {
          subdata.data.push(obj);
        }
      });
      console.log(subdata, "subdata");
      if (tabs_index.value == 1 && subdata.data.length > 1) {
        proxy.$alert("一次只能提交一个合同号下的商品", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            submitClick.value = true;
          },
        });
        return;
      }
      if (tabs_index.value == 2 && subdata.data.length > 1) {
        proxy.$alert("一次只能提交一个仓库下的商品", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            submitClick.value = true;
          },
        });
        return;
      }
      // if(subdata.data.length == 0) {
      //     proxy.$alert('未选中任何商品', '提示', {
      //         confirmButtonText: '确定',
      //         callback: action => {
      //             submitClick.value = true
      //         }
      //     })
      //     return
      // }
      let type = Number(tabs_index.value) + 1; //订单类型
      proxy
        .$confirm("提交订单后将无法返回修改，确认提交吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let data = {
            postType: "createOrder",
            type: type, // 订单类型（1.普通订单 2.项目订单 3.异地仓订单 4.样品订单）
            hth: hth.value, // 合同号（订单类型为2时必填）
            ydStock: ydStock.value, // 异地仓编码（订单类型为3时必填）
            ystockNo: ydStock.value,
            ydStockName: ydStockName.value, // 异地仓名称（订单类型为3时必填）
            ystockName: ydStockName.value,
            data: JSON.stringify(subdata), // 订单信息
          };
          proxy.$axios
            .postReq("/meide/REST/ajaxCommitOrder", data)
            .then((res) => {
              if (res.success == "true") {
                ElMessage.success({
                  message: res.Info,
                  type: "success",
                });
                submitClick.value = true;
                setTimeout(() => {
                  store.commit("shopCartRe", true);
                }, 1000);
                // router.push({
                //   name: "Settlement",
                //   params: {
                //     orderNum: res.orderNo,
                //   },
                // });
                router.push({
                  name: "Settlement",
                  params: {
                    id: res.orderNo,
                  },
                });
                // router.push(`/settlement/${res.orderNo}`);
              } else {
                proxy.$alert(res.ErrorText, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    submitClick.value = true;
                  },
                });
              }
            })
            .catch((error) => {
              submitClick.value = true;
            });
        })
        .catch(() => {
          submitClick.value = true;
        });
    };
    let hth = ref("");
    let ydStock = ref("");
    let ydStockName = ref("");
    // 提交前比较价格
    let priceCompare = () => {
      if (submitClick.value) {
        submitClick.value = false;
        let comparedata = [];

        pageData.cartList.map((item) => {
          let current_hth = item.hth;
          let current_stockCode = item.stockCode;
          let current_stockName = item.stockName;
          item.proData.map((it) => {
            let ob = {
              productCode: "",
              price: "",
              tsdId: "",
              jppz: "",
            };
            if (it.selsig) {
              ob.productCode = it.code;
              ob.price = it.price;
              ob.tsdId = it.tsdId;
              ob.jppz = it.jppz;
              comparedata.push(ob);
              hth.value = current_hth;
              ydStock.value = current_stockCode;
              ydStockName.value = current_stockName;
            }
          });
        });
        if (comparedata.length == 0) {
          proxy.$alert("未选中任何商品", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              submitClick.value = true;
            },
          });
          return;
        }

        let data = {
          postType: "comparePrice",
          data: JSON.stringify(comparedata), // 订单信息
        };

        proxy.$axios
          .postReq("/meide/REST/ajaxCommitOrder", data)
          .then((res) => {
            if (res.success == "true") {
              if (res.same) {
                // 价格没有变化
                cartSubmit();
              } else {
                proxy
                  .$confirm(
                    "商品价格发生变化，是否返回页面查看？（点击取消将直接前往结算）",
                    "提示",
                    {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    }
                  )
                  .then(() => {
                    for (let b = 0; b < pageData.cartList.length; b++) {
                      for (
                        let c = 0;
                        c < pageData.cartList[b].proData.length;
                        c++
                      ) {
                        for (let a = 0; a < res.data.length; a++) {
                          if (
                            res.data[a].tsdId ==
                            pageData.cartList[b].proData[c].tsdId
                          ) {
                            pageData.cartList[b].proData[c].price =
                              res.data[a].price;
                            pageData.cartList[b].proData[c].totalPrice = Nummul(
                              pageData.cartList[b].proData[c].num,
                              pageData.cartList[b].proData[c].price
                            ).toFixed(2);
                          }
                        }
                      }
                    }
                    submitClick.value = true;
                  })
                  .catch(() => {
                    cartSubmit();
                  });
              }
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  submitClick.value = true;
                },
              });
            }
          })
          .catch((error) => {
            submitClick.value = true;
          });
      }
    };
    // 跳转产品详情
    let pageToDetail = (jppz, cz, xs) => {
      router.push({
        name: "ProductDetails",
        query: {
          pz: jppz,
          cz: cz,
          xs: xs,
        },
      });
    };
    onBeforeMount(() => {
      getShoppingCart();
    });
    let orderType = ref(1);
    let clickTab = (index) => {
      tabs_index.value = index;
      orderType.value = index + 1;
      getShoppingCart();
    };
    return {
      ...toRefs(pageData),
      getShoppingCart,
      delClick,
      deletGoods,
      colClick,
      productCollect,
      selectAll,
      numChange,
      numCheck,
      submitClick,
      cartSubmit,
      priceCompare,
      totalhxPrice,
      totalPricereal,
      totalSelNum,
      totalWeight,
      pageToDetail,
      allKcCheck,
      totalBoxNum,
      totalNum,
      tabs,
      tabs_index,
      clickTab,
    };
  },
};
</script>

<style scoped lang="scss">
.main {
  padding-bottom: 100px;
}
.maincon {
  width: 1200px;
  margin: auto;
  padding-top: 30px;
}
.tabs {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  .cell {
    width: 130px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 5px 5px 0 0;
    color: #999;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: #333;
    }
  }
  .cell.active {
    background: rgba(244, 36, 52, 1);
    color: #fff;
  }
}
.cartbox {
  .stepbox {
    height: 60px;
    ::v-deep(.el-steps) {
      float: right;
      width: 500px;
    }
  }
  .cartcon {
    .item {
      margin-bottom: 40px;
      h2 {
        p {
          padding: 5px 20px;
          color: #fff;
          background: rgba(244, 36, 52, 1);
          border-radius: 200px;
          font-size: 16px;
        }
        span {
          color: rgba(244, 36, 52, 1);
          margin-left: 30px;
        }
      }
      .top {
        padding: 15px;
        background-color: rgba(250, 250, 250, 1);
        border-top: 2px solid rgba(244, 36, 52, 1);
        margin-top: 10px;
        margin-bottom: 20px;
        div {
          margin: 0 2px;
          text-align: center;
        }
        .checkbox {
          width: 18px;
          height: 18px;
        }
        .msg {
          width: 350px;
        }
        .stock {
          width: 70px;
        }
        .deliver {
          width: 100px;
        }
        .price {
          width: 120px;
        }
        .num {
          width: 130px;
        }
        .cases {
          width: 130px;
        }
        .weight {
          width: 90px;
        }
        .total {
          flex-grow: 1;
          width: 90px;
        }
      }
      .cell {
        padding: 0 15px;
        border: 1px solid rgb(235, 235, 235);
        div {
          margin: 0 2px;
        }
        .checkbox {
          width: 18px;
        }
        .msg {
          width: 350px;
          .img {
            padding: 15px;
            img {
              width: 90px;
              height: 90px;
              cursor: pointer;
            }
          }
          .name {
            p {
              margin-bottom: 5px;
            }
            span {
              font-size: 12px;
            }
          }
        }
        .stock {
          width: 70px;
          text-align: center;
        }
        .deliver {
          width: 100px;
          text-align: center;
        }
        .price {
          width: 120px;
          text-align: center;
          .redw {
          }
          .grayw {
            font-size: 12px;
            margin-top: 5px;
            text-decoration: line-through;
          }
        }
        .num {
          margin-right: 10px;
        }
        .cases {
        }
        .weight {
          width: 90px;
          text-align: center;
          font-size: 12px;
        }
        .total {
          flex-grow: 1;
          text-align: center;
        }
      }
    }
  }
}
.totalall {
  padding-left: 15px;
  border: 1px solid rgb(235, 235, 235);
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  width: 100%;
  background: #fff;
  .totalallcon {
    width: 1200px;
    margin: auto;
    justify-content: space-between;
  }
  .left {
    width: 240px;
    justify-content: space-between;
    ::v-deep(.el-button) {
      span {
        font-size: 12px;
        color: #999;
        &:hover {
          color: rgba(244, 36, 52, 1);
        }
      }
    }
  }
  .right {
    color: #999;
    font-size: 13px;
    p {
      color: #999;
      font-size: 13px;
      margin: 0 10px;
      span {
      }
      .large {
        font-size: 22px;
        font-weight: bold;
      }
    }
    .submitbtn {
      cursor: pointer;
      width: 165px;
      height: 60px;
      color: #fff;
      background: rgba(244, 36, 52, 1);
      line-height: 60px;
      text-align: center;
      margin-left: 20px;
      font-size: 20px;
    }
  }
}
.nodata {
  padding-top: 100px;
}
</style>
